import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function BottomNav() {
  const location = useLocation();

  const tabs = [
    { path: '/dashboard', label: 'Home', icon: '\u2302' },
    { path: '/search', label: 'Search', icon: '\u2315' },
    { path: '/log', label: 'Log', icon: '\u2630' },
    { path: '/settings', label: 'Settings', icon: '\u2699' }
  ];

  return (
    <nav className="bottom-nav">
      {tabs.map(tab => (
        <Link
          key={tab.path}
          to={tab.path}
          className={`bottom-nav-item ${location.pathname === tab.path || location.pathname.startsWith(tab.path + '/') ? 'active' : ''}`}
        >
          <span className="bottom-nav-icon">{tab.icon}</span>
          <span className="bottom-nav-label">{tab.label}</span>
        </Link>
      ))}
    </nav>
  );
}

export default BottomNav;
